const URLHelper = require('../utils/URLHelper.js');
const http = require('../utils/HTTPService.js');
const StorageService = require('../utils/StorageService');
const _ = require('lodash');

function SignUpService() {

    let ON_LOGIN_END = [];
    let currentUser;

    this.login = function(data) {
        const url = URLHelper.getLogin();
        return http.post(url, data)
        .then((result) => {
            const user = _.get(result, 'user');
            return handleUser(user);
        });
    };

    /*this.create = function (organization, form) {
        let url = URLHelper.getSignUp();
        organization.features = {
            slidePresentation: {
                name: "slidePresentation",
                status: "active",
                preferences: form
            }
        };
        return http.post(url, organization);
    };

    this.findDemoOrganization = function (handle) {
        let url = URLHelper.getFindOrganization();
        let query = {
            handle: handle
        };
        return http.get(url, query);
    };

    this.findDemoByName = function (name) {
        let query = {
            term: name
        };
        let url = URLHelper.getFindOrganizationsByName(query);
        return name ? http.get(url) : Promise.resolve([]);
    };*/

    this.findDemoByHandle = function (handle) {
        const url = URLHelper.getFindDemo(handle);
        return http.get(url);
    };

    this.updateDemo = function (handle, data) {
        const url = URLHelper.getFindDemo(handle);
        return http.post(url, data);
    };

    this.updateOrganization = function(handle, dataToUpdate) {
        return this.getCurrentOrganization().then((organization) => {
            const data = {
                features: {
                    slidePresentation: {
                        preferences: {
                            demos: {
                                [handle]: dataToUpdate
                            }
                        }
                    }
                }
            };
            _.merge(organization, data);
            const url = URLHelper.getUpdateOrganization(organization._id);
            return http.post(url, {organization});
        });
    };

    this.getCurrentUser = function () {
        return currentUser ?
            Promise.resolve(currentUser) :
            http.get(URLHelper.getDashboardUser())
                .then(handleUser)
                .catch(handleError);
    };

    this.getCurrentOrganization = function () {
        return this.getCurrentUser().then((user) => {
            return user._organization;
        });
    };

    this.setCurrentUser = function(user) {
        currentUser = user;
    };

    this.createGuest = function (guest, organizationHandle, user) {
        let data = Object.assign({handle: organizationHandle}, guest);
        let url = user ? URLHelper.getUserView() : URLHelper.getGuestSignUp();
        return http.post(url, data);
    };

    this.unload = function (user, handle) {
        let blob = new Blob([JSON.stringify({user: user, handle: handle})], {type: 'application/json; charset=UTF-8'});
        navigator.sendBeacon(URLHelper.getBeacon(), blob);
    };

    function handleUser(user) {
        triggerLoginEnd(user);
        if (_.isString(user)) {
            throw new Error(URLHelper.getDashboardUser());
        }
        currentUser = user;
        http.setToken(user.token);
        return user;
    }

    function handleError(error) {
        console.error(error);
        triggerLoginEnd();
        return StorageService.getCurrentUser();
    }

    function triggerLoginEnd(user) {
        ON_LOGIN_END.forEach(l => l(user));
    }

    this.onLoginEnd = function (listener) {
        ON_LOGIN_END.push(listener);
    };

}

module.exports = new SignUpService();

// {
//     "name": "Pedro Henrique de Assis",
//     "segmentAnonymousId": "eb1abc1c-c494-487f-a7db-c17ba514e02d",
//     "username": "pedro+signuptest@callinize.com",
//     "password": "callinize",
//     "company": "PedroSignup",
//     "phoneNumber": "4155991170",
//     "crmProvider": "salesforce",
//     "phoneSystem": "asterisk"
// }


//////////////////
// WEBPACK FOOTER
// ./form/components/signup/SignUpService.js
// module id = 5
// module chunks = 0 1